import { ErrorBoundary } from "./error-boundary";
import PrivateRoute from "./private-route";
import PublicRoute from "./public-route";
import ProtectedRoute from "./protected-route";

export function MapRoutes(routes) {
  // console.log("Mapping routes:", routes);
  return routes.map((route) => {
    const children = route.children ? MapRoutes(route.children) : undefined;

    let element = route.element;
    if (route?.public === true) {
      element = (
        <PublicRoute>
          <ErrorBoundary>{route.element} </ErrorBoundary>
        </PublicRoute>
      );
    } else if (route?.requiredPermissions) {
      element = (
        <ProtectedRoute
          requiredPermissions={route.requiredPermissions}
          redirectTo={route.redirectTo || "/"}
        >
          <ErrorBoundary>{route.element}</ErrorBoundary>
        </ProtectedRoute>
      );
    } else {
      element = (
        <PrivateRoute>
          <ErrorBoundary>{route.element}</ErrorBoundary>
        </PrivateRoute>
      );
    }

    return {
      ...route,
      element,
      children,
    };
  });
}
